import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';
import { Reason, ReasonCard } from '../ReasonCard/ReasonCard';

type ReasonsWrapperProps = {
    reasons: ReadonlyArray<Readonly<Reason>>;
};

const StyledBox = styled(Box)`
    ${mediaQuery.minimum('normal')} {
        > *:nth-child(even) {
            padding-left: ${spaces.px['1.5bu']};
        }
    }
`;

export const ReasonsWrapper = ({ reasons }: ReasonsWrapperProps) => {
    return (
        <StyledBox display="flex" paddingBottom={['2bu', '2bu', '3bu', 'none']} flexWrap="wrap">
            {reasons.map((reason, index) => (
                <ReasonCard reason={reason} key={index} />
            ))}
        </StyledBox>
    );
};
